export const NO_DATA = "admin.reporting.error.empty"
const SERVER_ERROR = "errors.PBDEAInternalServerError"

interface Error {
  networkError: PBError
}

export default function (err: Error): any {
  const httpStatus = err?.networkError?.apiError?.response?.data?.httpStatus

  switch (httpStatus) {
    case 404:
      return NO_DATA
    case 500:
      return SERVER_ERROR
    default:
      return NO_DATA
  }
}
